import { Card } from 'antd';
import { useUserHasPermission } from 'hooks';
import { useParams } from 'react-router-dom';

/**
 * @description Bu komponent, ayk control, eu control ve pub control asamasinda yollanan notlari görüntüler.
 * @param {string} aykControlDescription - Ayk control asamasinda yollanan not
 * @param {string} euControlDescription - Eu control asamasinda yollanan not
 * @params {string} ownerCommitteeOpinion - Sorumlu ilim heyeti görüşü
 *  @param {string} pubControlDescription - Pub control asamasinda yollanan not
 * @params {string} ownerCommitteeOpinion - Sorumlu ilim heyeti görüşü
 * @params {number} ownerCommiteeId - Sorumlu ilim heyetinin komitesi id degeri
 * @params {boolean} userIsEuManager - Kullanıcının eu manager olup olmadığı bilgisi
 * @params {string} redactionNote - Redaksiyon kararı ile gelen notlar
 * @returns
 */
function ComitteeDescriptionArea({
  ownerCommiteeId = null,
  userIsEuManager,
  aykControlDescription,
  euControlDescription,
  pubControlDescription,
  ownerCommitteeOpinion,
  redactionNote = null,
}) {
  const { committee } = useParams();
  const { handlePermission } = useUserHasPermission();

  const handleShowOwnerCommitteeOpinion = () => {
    const isEuControl = committee === 'eu_control';
    const isUserOnOwnerCommittee = ownerCommiteeId && handlePermission(ownerCommiteeId);
    const isUserEuManager = userIsEuManager;
    const isOwnerCommitteeOpinion = ownerCommitteeOpinion && ownerCommitteeOpinion.length > 0;
    return isEuControl && isOwnerCommitteeOpinion && (isUserOnOwnerCommittee || isUserEuManager);
  };

  return (
    <>
      <Card className={`${aykControlDescription ? 'gx-display-block' : 'gx-display-none'}`}>
        <h3>Ansiklopedi yönetim kurulu Notu</h3>
        <span>{aykControlDescription}</span>
      </Card>
      <Card className={`${euControlDescription ? 'gx-display-block' : 'gx-display-none'}`}>
        <h3>Ansiklopedi birimi Notu</h3>
        <span>{euControlDescription}</span>
      </Card>
      <Card className={`${pubControlDescription ? 'gx-display-block' : 'gx-display-none'}`}>
        <h3>Yayın mudurlugu kontrol Notu</h3>
        <span>{pubControlDescription}</span>
      </Card>
      <Card className={`${handleShowOwnerCommitteeOpinion() ? 'gx-display-block' : 'gx-display-none'}`}>
        <h3>Sorumlu ilim heyeti Notu</h3>
        <span>{ownerCommitteeOpinion}</span>
      </Card>
      <Card className={`${redactionNote ? 'gx-display-block' : 'gx-display-none'}`}>
        <h3>Redaksiyon Kararı ile Gelen Notlar</h3>
        <span>{redactionNote}</span>
      </Card>
    </>
  );
}
export default ComitteeDescriptionArea;
